var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pole-container"},[_c('PoleGroupIndex',{attrs:{"devices":_vm.devices}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }